export default "__VITE_ASSET__0fFbz12a__"